<template>
  <el-dialog title="Retirar Placa do Imóvel" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="30%">
    <el-form size="small" label-position="top">
      
      <el-form-item label="Placa Instalada">
        <el-input :value="placa.tipo" readonly disabled />
      </el-form-item>

      <el-form-item label="Situação da Retirada" style="width: 100%">
        <el-select v-model="placa.status" style="width: 100%">
          <el-option
            v-for="item in ocorrenciaRetiradaPlaca"
            :key="item.data"
            :label="item.label"
            :value="item.data">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Responsável pela Retirada" style="width: 100%">
        <el-select v-model="usuarioRetirada"
          :remote-method="recuperarUsuariosSelect"
          :loading="loadingUsuarios"
          value-key="id"
          placeholder="Pesquise o Colaborador"
          filterable
          remote
          reserve-keyword
          style="width: 100%">
          <el-option
            v-for="item in usuariosDisponiveis"
            :key="item.id"
            :label="item.nome"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Data de Retirada">
        <el-date-picker
          v-model="dataRemocao"
          v-mask="'##/##/####'"
          type="date"
          format="dd/MM/yyyy"
          value-format="dd/MM/yyyy"
          style="width: 100%"
        />
      </el-form-item>

    </el-form>
    <span slot="footer">
      <el-button @click="retirarPlaca()" type="primary" size="small" round class="btn-box-shadow">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Util from '../../../util/funcoes.js'
import { OCORRENCIA_RETIRADA_PLACA } from '../../../util/constantes.js';

export default {
  props: {
    placa: Object,
    visibility: Boolean
  },
  data() {
    return {
      loadingUsuarios: false,
      status: 'RETIRADA',
      usuarioRetirada: { id: 0 },
      dataRemocao: Util.hoje(),
      usuariosDisponiveis: []
    }
  },
  computed: {
    ...mapState('loginStore', {
      usuarioLogado(state) { return state.usuarioLogado }
    }),
    ...mapState('alugueisImoveisStore', {
      imovel(state) { return state.imovelSelecionado }
    }),
    ocorrenciaRetiradaPlaca() { return OCORRENCIA_RETIRADA_PLACA }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('alugueisImoveisStore', [
      'removerPlacaImovel',
      'listarUsuarios'
    ]),
    recuperarUsuariosSelect(queryString) {
      let payload = { nome: queryString };
      this.loadingUsuarios = true;
      
      this.listarUsuarios(payload)
        .then((resultado) => {
          this.loadingUsuarios = false;
          if (resultado.status === "SUCESSO") {
            this.usuariosDisponiveis = resultado.lista;
          }
        })
        .catch(() => {
          this.loadingUsuarios = false;
        });
    },
    retirarPlaca() {
      if(!this.usuarioRetirada || !this.usuarioRetirada.id) {
        this.$message.warning("Selecione o responsável pela retirada");
        return;
      }
      
      let idImovel = this.imovel && this.imovel.id ? this.imovel.id : (this.$route && this.$route.params ? this.$route.params.id : 0);
      if (idImovel === 0) {
        this.$message.error("Tente atualizar a página.");
        return;
      }

      let payload = {
        ...this.placa,
        tipo: this.placa.tipo,
        status: this.placa.status || this.status,
        imovel: { id: idImovel },
        dataRemocao: this.dataRemocao,
        usuarioRetirada: { 
          id: this.usuarioRetirada.id,
          nome: this.usuarioRetirada.nome
        }
      };

      this.showLoading()
      this.removerPlacaImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Erro ao comunicar com o servidor.");
      });
    },
    fechar() {
      this.$emit('close');
    }
  },
  watch: {
    visibility(val) {
      if (val) {
        const logado = Object.assign({}, this.usuarioLogado);
        this.usuariosDisponiveis = [logado];
        this.usuarioRetirada = logado;
      }
    }
  }
}
</script>
